<template>
  <div
    v-if="user"
    class="ticket-user"
  >
    <user-image
      :image-src="user.profile_picture"
      size="sm"
    />
    <small>
      {{ user.name }}
    </small>
  </div>
</template>

<script>
import UserImage from "../../global/assets/UserImage.vue";

export default {
  components: {
    UserImage,
  },
  props: {
    user: {
      type: [Object, null],
      required: true,
    }
  }
}
</script>

<style scoped>
.ticket-user {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
